import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { InterfaceButton, InterfaceStyles, InterfaceTextInput } from "../Components/Interface";
import { CenterBlueTitle, RevealSection } from "../Landing/Landing";
import { faCheck, faFile, faFileArrowDown, faFileCode, faFileContract, faFileLines, faFilePdf, faLock, faPhotoFilm, faPlay, faVideo } from "@fortawesome/free-solid-svg-icons";
import { useSite } from "../Context/SiteContext";
import React, { createContext, SetStateAction, useContext, useRef, useState, Dispatch, useEffect } from "react";

const BusinessContext = createContext<{
    password:{get:string,set?:Dispatch<SetStateAction<string>>},
    passwordAccepted:{get:boolean,set?:Dispatch<SetStateAction<boolean>>},
    username:{get:string,set?:Dispatch<SetStateAction<string>>},
}>({
    password:{get:''},
    passwordAccepted:{get:false},
    username:{get:''},
});

const useBusiness = () => useContext(BusinessContext);

export const Business = () => {

    const [password, setPassword] = useState('');
    const [passwordAccepted, setPasswordAccepted] = useState(false);
    const [username, setUsername] = useState('');

    return(
        <div style={{
            ...InterfaceStyles.standardColumn,
            minHeight:'100vh',            
            fontFamily:'Science Gothic',
            backgroundColor:"#111318",
            ...InterfaceStyles.center,
            gap:30,
        }}>
            <BusinessContext.Provider value={{
                password:{get:password,set:setPassword},
                passwordAccepted:{get:passwordAccepted,set:setPasswordAccepted},
                username:{get:username,set:setUsername},
            }}>
                <div style={{...InterfaceStyles.standardRow,gap:0,}}>
                    <CenterBlueTitle title={`Welcome`}></CenterBlueTitle>
                    <CenterBlueTitle title={username} rowStyle={{
                        paddingLeft: passwordAccepted ? 10 : 0,
                        maxWidth: passwordAccepted ? '50vw' : 0,
                        opacity: passwordAccepted ? 1 : 0,
                        transition:'all 5s ease',
                        overflow:'hidden',
                    }}></CenterBlueTitle>
                </div>
                {passwordAccepted ? <Content></Content> : <PasswordInput></PasswordInput>} 
            </BusinessContext.Provider>
        </div>
    );

};

const PasswordInput = () => {

    const Site = useSite();
    const Business = useBusiness();

    const textRef = useRef<HTMLInputElement>(null);

    const submitPassword = (value:string) => {
        fetch('/founder/pass',{
            method:'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({password: value}),
        }).then((res)=>{
            res.json().then((data) => {
                if(data.username){
                    Business.username.set?.(` ${data.username}`);
                    Business.password.set?.(value);
                    Business.passwordAccepted.set?.(true);
                }
            }).catch((err) => console.log(err));
        }).catch(err => {
            console.log(err);
        });
        
    };

    return(
        <div style={{...InterfaceStyles.standardRow}}>
            <FontAwesomeIcon icon={faLock} style={{...Site.styles?.copyText}}></FontAwesomeIcon>
            <InterfaceTextInput ref={textRef} value="" style={{textAlign:'left'}} onSubmit={submitPassword}></InterfaceTextInput>
            <InterfaceButton icon={faCheck} onClick={()=>{
                submitPassword(textRef.current?.value ?? '');
            }}></InterfaceButton>
        </div>
    );

};

const Content = () => {

    const Site = useSite();
    const Business = useBusiness();
    const [grow, setGrow] = useState(false);

    const [fileURL, setFileURL] = useState('');
    const fileAnchor = useRef<HTMLAnchorElement>(null);

    useEffect(()=>{
        setTimeout(()=>setGrow(Business.passwordAccepted.get),100);
    },[Business.passwordAccepted.get]);

    return(
        <div style={{
            ...InterfaceStyles.standardColumn,
            minHeight:40,
            maxHeight: grow ? '50vh' : 40,
            transition: 'max-height 5s ease',
            width:'100%',
            maxWidth:540,
            alignItems:'center',
        }}>
            <RevealSection style={{justifyContent:'center'}}>
                <a ref={fileAnchor} href={fileURL} target="_blank" hidden></a>
                <div style={{...Site.styles?.copyText, maxWidth:540,textAlign:'center', paddingBottom:20,}}>Thank you for being here. Let's change playback.</div>
                <div style={{...InterfaceStyles.standardRow,width:'100%'}}>
                    <InterfaceButton icon={faFileLines} text="Business Plan" style={{flex:1, justifyContent:'flex-start'}} onClick={()=>{
                        window.open('/founder/business-plan','_blank');
                    }}></InterfaceButton>
                </div>
                <div style={{...InterfaceStyles.standardRow,width:'100%'}}>
                    <InterfaceButton icon={faFileArrowDown} text="Version 0.1.2 Demo" style={{flex:1, justifyContent:'flex-start'}} onClick={()=>{
                        window.open('/founder/demo','_blank');
                    }}></InterfaceButton>
                </div>
                <div style={{...InterfaceStyles.standardRow,width:'100%'}}>
                    <InterfaceButton icon={faFileCode} text="Interactive Assets" style={{flex:1, justifyContent:'flex-start'}} onClick={()=>{
                        window.open('/founder/interactive','_blank');
                    }}></InterfaceButton>
                </div>
            </RevealSection>
        </div>
    );

};
 